import { useRef } from 'react';

let instances = 0;

/**
 * A DOM id unique to one mounted component, for labels and ARIA relationships. React 17
 * has no `useId`, and a module-level constant collides across two of the same component.
 *
 * @param {string} prefix - Readable prefix for the generated id
 * @returns {string} An id stable for the life of this instance
 */
export const useInstanceId = prefix => {
    const id = useRef(null);
    if (id.current === null) {
        instances += 1;
        id.current = `${prefix}-${instances}`;
    }
    return id.current;
};

export default useInstanceId;
